import NewsList from "./NewsList";
import "./News.css";
import Pagination from "./Pagination";
import { useParams } from "react-router-dom";
import SkeletonCard from "../SkeletonCard";

function News({ news, totalPages, currentPage, isLoading }) {
  const { pn } = useParams();
  const pageNum = Math.max(1, Number(pn) || currentPage || 1);

  return (
    <>
      <main className="main_container">
        {isLoading ? (
          Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)
        ) : news && news.length > 0 ? (
          <NewsList articles={news} />
        ) : (
          <p>No news found</p>
        )}
      </main>
      {totalPages > 1 && <Pagination total_page={totalPages} page={pageNum} />}
    </>
  );
}

export default News;
